var _excluded = ["currency", "label"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { j as o } from "./index.es33.js";
import { BaseInput as c } from "./index.es62.js";
import { formatValue as g } from "./index.es126.js";
import x from "./index.es127.js";

var v = function v(_ref) {
  var _ref$currency = _ref.currency,
      a = _ref$currency === void 0 ? "usd" : _ref$currency,
      _ref$label = _ref.label,
      m = _ref$label === void 0 ? "Enter amount" : _ref$label,
      t = _objectWithoutProperties(_ref, _excluded);

  var n = g(t.value, a),
      s = (n.match(/\D/g) || []).length,
      r = t.maxLength ? t.maxLength + s : void 0,
      u = function u(l) {
    var i = l.replace(/[^0-9]+/g, ""),
        e = parseInt(i, 10);
    t.onChange(Number.isNaN(e) ? null : e);
  };

  return o.jsx("div", {
    className: x.container,
    children: o.jsx(c, _objectSpread(_objectSpread({}, t), {}, {
      label: m,
      value: n,
      onChange: u,
      maxLength: r
    }))
  });
};

export { v as MoneyInput };